import styles from "./questionDate.module.scss";

export function QuestionDate(props: Props) {
  if (!props.date) return <></>;

  return (
    <p className={styles["date"]}>
      Last updated: {new Date(props.date)?.toLocaleDateString("en-US")}
    </p>
  );
}

interface Props {
  date?: string;
}
